import React from 'react';
import { Breadcrumb, Layout, notification, Modal } from 'antd/lib';
import * as Icons from '@ant-design/icons';

import { graphql, withApollo } from 'react-apollo';

import Loading from '../../../common/Loading';

import FormTipoCertificacion from './FormTipoCertificacion';
import updateTipoCertificacionPorId from '../../../../graphql/mutations/otros/updateTipoCertificacionPorId.graphql';
import getTipoCertificacionPorId from '../../../../graphql/querys/otros/getTipoCertificacionPorId.graphql';
import { errorService } from '../../../../graphql/utils/utils';

const estiloContent = {
  marginTop: 16,
  border: '1px dashed #e9e9e9',
  borderRadius: 6,
  backgroundColor: '#fafafa',
  paddingTop: 20,
};

@graphql(updateTipoCertificacionPorId, {
  name: 'updateTipoCertificacionPorId',
})
class EditarTipoCertificacion extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      step: 0,
      loading: true,
    };

    this.props.client
      .query({
        query: getTipoCertificacionPorId,
        variables: { _id: this.props.match.params.id },
      })
      .then(res => {
        const tipo_certificacion = res.data.getTipoCertificacionPorId;

        this.setState({
          loading: false,
          tipo_certificacion: tipo_certificacion,
        });
      })
      .catch(err => {
        console.log('Error en la creacion');
        console.log(err);
        errorService(err, {
          _id: this.props.match.params.id,
        });

        Modal.error({
          title: 'Error en la inicializacion del componente grafico',
          content:
            'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
        });
      });

    this.guardarTipoCertificacion = this.guardarTipoCertificacion.bind(this);
    this.onCancel = this.onCancel.bind(this);
  }

  guardarTipoCertificacion(tipo_certificacion) {
    this.setState(
      {
        tipo_certificacion: {
          ...this.state.tipo_certificacion,
          ...tipo_certificacion,
        },
      },
      function() {
        this.props
          .updateTipoCertificacionPorId({
            variables: {
              _id: this.props.match.params.id,
              nuevoNombre: this.state.tipo_certificacion.nombre,
            },
          })
          // eslint-disable-next-line no-unused-vars
          .then(res => {
            notification.success({
              message: 'Actualizacion Correcta',
              description:
                'Se ha registrado los nuevos datos del tipo de certificacion',
            });

            this.props.history.push('/admin/otros/tipo_certificacion');
          })
          .catch(err => {
            console.log('Error en la actualizacion del tipo de certificacion');
            console.log(err);
            errorService(err, {
              _id: this.props.match.params.id,
              nuevoNombre: this.state.tipo_certificacion.nombre,
            });
            Modal.error({
              title: 'Error en la actualizacion del tipo de certificacion',
              content:
                'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
            });
          });
      }
    );
  }

  onCancel() {
    this.setState({
      fase: 0,
    });
  }

  render() {
    if (this.state.loading) {
      return <Loading />;
    }

    return (
      <div>
        <Breadcrumb
          style={{
            margin: '12px 0',
          }}
        >
          <Breadcrumb.Item>Tipo de Certificacion</Breadcrumb.Item>
          <Breadcrumb.Item>Editar</Breadcrumb.Item>
        </Breadcrumb>
        <Layout
          style={{
            background: '#fff',
            padding: 24,
            minHeight: '80vh',
          }}
        >
          <h2 style={{ marginBottom: 10, textAlign: 'center' }}>
            <Icons.FileTextOutlined /> Editar Tipo de Certificacion
          </h2>
          <br />
          <div style={estiloContent}>
            <FormTipoCertificacion
              className="formularios"
              onSubmit={this.guardarTipoCertificacion}
              onAnterior={() =>
                this.props.history.push('/admin/otros/tipo_certificacion')
              }
              datos={this.state.tipo_certificacion}
            />
          </div>
        </Layout>
      </div>
    );
  }
}

export default withApollo(EditarTipoCertificacion);
